import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-arbitrato-view',
  templateUrl: './form-arbitrato-view.component.html',
  styleUrls: ['./form-arbitrato-view.component.css']
})
export class FormArbitratoViewComponent {

  @Input() ctxBodyFascicolo;
  constructor() {}
}
